"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggleMinorVersionOption = exports.getStatusLabel = exports.getPreviousIndex = exports.getNextIndex = exports.getMinorVersionOptions = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _types = require("../LifecycleState/types");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var getStatusLabel = exports.getStatusLabel = function getStatusLabel(status) {
  var _statusMap$status;
  var statusMap = (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, _types.AssetStatus.PUBLISHED, 'Latest stable'), _types.AssetStatus.DEPRECATED, 'Latest deprecated'), _types.AssetStatus.DEVELOPMENT, 'Latest in development');
  return (_statusMap$status = statusMap[status]) !== null && _statusMap$status !== void 0 ? _statusMap$status : status;
};
var getVisibilityLabel = function getVisibilityLabel(isPublic) {
  return isPublic ? 'Public' : 'Private';
};
var generateVersionGroupSeparator = function generateVersionGroupSeparator(accum, _ref) {
  var _accum;
  var versionGroup = _ref.versionGroup,
    isPublic = _ref.isPublic;
  if (((_accum = accum[accum.length - 1]) === null || _accum === void 0 ? void 0 : _accum.versionGroup) === versionGroup) {
    return [];
  }
  return [{
    versionGroup: versionGroup,
    visibility: getVisibilityLabel(isPublic),
    type: 'label'
  }];
};
var getMinorsByStatus = function getMinorsByStatus(minorVersion, versionGroup, statuses, isMinorOpen) {
  return statuses.map(function (status, index) {
    return {
      minorVersion: minorVersion,
      versionGroup: versionGroup,
      status: status,
      isMinorOpen: isMinorOpen,
      isLatest: index === statuses.length - 1
    };
  });
};
var getMinorVersionOptions = exports.getMinorVersionOptions = function getMinorVersionOptions(assetMinorVersions, isVersionGroupNavigation, asset) {
  return assetMinorVersions.reduce(function (accum, minorVersionOption) {
    var minorVersion = minorVersionOption.minorVersion,
      versionGroup = minorVersionOption.versionGroup,
      statuses = minorVersionOption.statuses;
    var separator = isVersionGroupNavigation ? generateVersionGroupSeparator(accum, minorVersionOption) : [];
    return [].concat((0, _toConsumableArray2.default)(accum), (0, _toConsumableArray2.default)(separator), [{
      isRoot: true,
      minorVersion: minorVersion,
      versionGroup: versionGroup,
      status: '',
      isMinorOpen: minorVersion === asset.minorVersion
    }], (0, _toConsumableArray2.default)(getMinorsByStatus(minorVersion, versionGroup, statuses, minorVersion === asset.minorVersion)));
  }, []);
};
var toggleMinorVersionOption = exports.toggleMinorVersionOption = function toggleMinorVersionOption(minorVersionOptions, minorVersion) {
  return minorVersionOptions.map(function (option) {
    return (option === null || option === void 0 ? void 0 : option.minorVersion) === minorVersion ? _objectSpread(_objectSpread({}, option), {}, {
      isMinorOpen: !(option !== null && option !== void 0 && option.isMinorOpen)
    }) : option;
  });
};
var getNextIndex = exports.getNextIndex = function getNextIndex(index, length) {
  return index === length - 1 ? 0 : index + 1;
};
var getPreviousIndex = exports.getPreviousIndex = function getPreviousIndex(index, length) {
  return index === 0 ? length - 1 : index - 1;
};
//# sourceMappingURL=utils.js.map